module.exports = __webpack_public_path__ + "5e08743fb3075ad8e259ace471b4b76a.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/colossal_clashes-420.jpg
// module id = 226
// module chunks = 0